import Box from "@mui/material/Box"
import Typography from "@mui/material/Typography"
import EmojiEventsOutlinedIcon from "@mui/icons-material/EmojiEventsOutlined"
import ErrorOutlineOutlinedIcon from "@mui/icons-material/ErrorOutlineOutlined"
import React from "react"

const getMedalColor = (medal) => {
  if (medal === "gold") return "#f3b742"
  if (medal === "silver") return "#cfd6df"
  if (medal === "bronze") return "#d6843d"

  return "#d7d0c3"
}

export default function Prizes({ prizes }) {
  return (
    <Box
      sx={{
        mx: "auto",
        p: {
          xs: 2,
          sm: 2.5,
          md: 3,
        },
        borderRadius: 1,
        border: "1px solid rgba(196,150,84,0.2)",
        background: "linear-gradient(180deg, #000 60%, #121212 100%)",
      }}
    >
      <Box
        sx={{
          gap: 2,
          mb: 1.8,
        }}
      >
        <Typography
          sx={{
            color: "#f1f5f9",
            fontSize: {
              xs: 22,
              md: 27,
            },
            fontWeight: 900,
            lineHeight: 1,
            textTransform: "uppercase",
          }}
        >
          Prize distribution
        </Typography>

        <Typography
          sx={{
            color: "#dedede",
            fontSize: 16,
            mt: 2,
          }}
        >
          Rewards are distributed to top players based on their final
          leaderboard ranking.
        </Typography>
      </Box>

      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: {
            xs: "44px 44px minmax(150px, 1fr) 184px",
            sm: "44px 44px minmax(190px, 1fr) 240px",
          },
          alignItems: "center",
          px: {
            xs: 1,
            sm: 1.4,
          },
          py: 1,
          color: "#9aa5b1",
          fontSize: {
            xs: 12,
            sm: 14,
          },
          fontWeight: 800,
          borderBottom: "1px solid rgba(120, 145, 170, 0.16)",
          textTransform: "uppercase",
          textAlign: "center",
        }}
      >
        <Box></Box>
        <Box>Rank</Box>
        <Box>Reward (USDT)</Box>
        <Box>% of prize pool</Box>
      </Box>

      <Box>
        {prizes.map((row) => (
          <Box
            key={`${row.rank}-${row.reward}`}
            sx={{
              position: "relative",
              display: "grid",
              gridTemplateColumns: {
                xs: "44px 44px minmax(150px, 1fr) 184px",
                sm: "44px 44px minmax(190px, 1fr) 240px",
              },
              alignItems: "center",
              minHeight: {
                xs: 38,
                sm: 43,
              },
              px: {
                xs: 1,
                sm: 1.4,
              },
              fontSize: {
                xs: 12,
                sm: 14,
                md: 15,
              },
              fontWeight: 800,
              borderBottom:
                row.rank === 10
                  ? "1px solid #666"
                  : "1px solid rgba(120, 145, 170, 0.1)",
              color: "#eef3f8",
              textAlign: "center",
            }}
          >
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                color: getMedalColor(row.medal),
              }}
            >
              {row.medal && <EmojiEventsOutlinedIcon sx={{ fontSize: 22 }} />}
            </Box>

            <Typography
              sx={{
                fontSize: "inherit",
                fontWeight: 850,
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
              }}
            >
              {row.rank}
            </Typography>

            <Typography
              sx={{
                fontSize: "inherit",
                fontWeight: 850,
                overflow: "hidden",
                whiteSpace: "nowrap",
              }}
            >
              {row.reward}
            </Typography>

            <Typography
              sx={{
                fontSize: "inherit",
                fontWeight: 850,
              }}
            >
              {row.percent}
            </Typography>
          </Box>
        ))}
      </Box>

      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          mt: 3,
          py: 1,
          borderRadius: 1,
          border: "1px solid rgba(196,150,84,0.2)",
          background: "linear-gradient(180deg, #000 60%, #121212 100%)",
        }}
      >
        <ErrorOutlineOutlinedIcon
          sx={{ fontSize: 44, color: "#c49654", mx: 1.5 }}
        />
        Winnings will be automatically credited to your balance on the website
        after the tournament ends.
      </Box>
    </Box>
  )
}
